// src/components/ErrorBoundary.js
import React from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught in ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h2>Something went wrong.</h2>
          <p>{this.state.error?.message || 'An unexpected error occurred.'}</p>
          <button onClick={() => (window.location.href = '/')}>Go to Home</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;